import { CompanyEditPage } from "@/features/company/pages/CompanyEdit";
import React from "react";

const CompanyEdit = () => {
  return <CompanyEditPage />;
};

export default CompanyEdit;
